exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/_wks-ext.js
// module id = 29
// module chunks = 0